import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCartArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z",
		fill: "currentColor"
	})
});
export { SvgCartArrowLeft as ReactComponent };
